import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();
  return (
    <div className="page-container">
      <h1>{t.Services}</h1>
      <p>Page Services - ATC</p>
    </div>
  );
};

export default Services;